<template>
  <v-container class="pt-0 stats-container">
    <v-row
      v-if="getIsAdmin === true"
      class="f-s"
      align="stretch"
      :dense="$vuetify.breakpoint.smAndDown"
    >
      <v-col
        cols="12"
        sm="6"
        :order-sm="1"
        :order="2"
        style="
            display: flex;
            flex-direction: column;
            align-items: stretch;
            align-content: stretch;
            justify-items: stretch;
            justify-content: stretch;
        "
      >
        <v-tabs
          style="flex-grow: 0; flex-shrink: 1;"
          background-color="transparent"
          class="transparent"
          v-model="tabChart"
          grow
          :show-arrows="false"
        >
          <v-tab><v-icon x-small left>fa-marker</v-icon>Corrections</v-tab>
          <v-tab
            ><v-icon
              :color="getExpirationTabColor"
              :size="getExpirationTabColor === 'primary' ? 'x-small' : 'large'"
              left
              >fa-exclamation-triangle</v-icon
            >
            <span
              :class="{
                'primary--text': getExpirationTabColor === 'primary',
                'error--text': getExpirationTabColor === 'error',
                'warning--text': getExpirationTabColor === 'warning'
              }"
              >Expirations</span
            >
          </v-tab>
        </v-tabs>
        <v-card height="60vh" style="flex-grow: 1; flex-shrink: 0;">
          <v-card-text style="height: 100%">
            <v-tabs-items
              touchless
              v-model="tabChart"
              continuous
              style="height: 100%"
            >
              <v-tab-item tyle="height: 100%">
                <v-row dense align="center" justify="space-between" no-gutters>
                  <span class="overline font-weight-medium ml-2 primary--text"
                    >Produits surveillés</span
                  >
                  <v-btn
                    small
                    icon
                    @click="$router.push({ name: 'StatisticsDetails' })"
                  >
                    <v-icon small>far fa-chart-bar</v-icon>
                  </v-btn>
                </v-row>
                <div style="height: 25vh; overflow: auto;">
                  <PinnedProductChart></PinnedProductChart>
                </div>

                <v-divider class="my-1"></v-divider>
                <v-row
                  dense
                  no-gutters
                  class="mb-1"
                  align="center"
                  justify="space-between"
                >
                  <span class="overline font-weight-medium ml-2 primary--text"
                    >Récentes</span
                  >
                  <div style="width: 175px">
                    <v-text-field
                      class="small-input no-before"
                      filled
                      dense
                      height="20px"
                      rounded
                      hide-details
                      v-model="correctionSearch"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon x-small>fa-search</v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <div>
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on">
                          <v-icon small>fas fa-arrows-alt-v</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-list dense>
                            <v-list-item
                              v-for="item in correctionSortItems"
                              :key="item.value"
                              @click="correctionSort = item.value"
                            >
                              <v-list-item-title
                                :class="{
                                  'success--text': item.value === correctionSort
                                }"
                                >{{ item.text }}</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-btn small icon v-on="on">
                          <v-icon small>fa-filter</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-list dense>
                            <v-list-item
                              v-for="item in correctionDeltaItems"
                              :key="item.value"
                              @click="correctionDelta = item.value"
                            >
                              <v-list-item-title
                                :class="{
                                  'success--text':
                                    item.value === correctionDelta
                                }"
                                >{{ item.text }}</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                </v-row>
                <div style="height: 23vh; overflow: auto;">
                  <CorrectionProductChart
                    :delta="correctionDelta"
                    :search="correctionSearch"
                    :sort="correctionSort"
                  ></CorrectionProductChart>
                </div>
              </v-tab-item>
              <v-tab-item style="height: 100%">
                <InventoryExpirationAndWasteFilter
                  :showWaste.sync="expirationFilter.showWaste"
                  :showExpiration.sync="expirationFilter.showExpiration"
                ></InventoryExpirationAndWasteFilter>
                <div style="height: 95%; overflow: auto;" ref="chartCard">
                  <InventoryExpirationAndWasteGrid
                    :loading="loading"
                    :filter="expirationFilter"
                  ></InventoryExpirationAndWasteGrid>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" :order="1" :order-sm="2">
        <v-row
          align="center"
          justify="end"
          no-gutters
          :class="{ 'py-3': $vuetify.breakpoint.xsOnly }"
        >
          <ProductionDialog></ProductionDialog>
          <div
            class="py-1"
            style="width: 1px;"
            v-if="$vuetify.breakpoint.xsOnly"
          ></div>
          <InventoryWasteDialog></InventoryWasteDialog>
        </v-row>
        <v-card
          height="20vh"
          class="mt-3"
          :class="{ 'py-3': $vuetify.breakpoint.xsOnly }"
        >
          <v-card-text class="card-flex">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span
                class="primary--text overline font-weight-medium ml-3"
                style="cursor: pointer;"
                @click="$router.push({ name: 'PreparationSlipIndex' })"
                >Bons de préparation récents</span
              >
              <v-btn
                small
                text
                class="btn-success-transparent"
                color="success"
                :to="{ name: 'PreparationSlipEditor' }"
              >
                <v-icon left x-small>fa-plus</v-icon>
                Nouveau
              </v-btn>
            </v-row>
            <div class="small-card-scroller dense-table">
              <ProductionGrid :loading="loading"></ProductionGrid>
            </div>
          </v-card-text>
        </v-card>
        <v-card height="20vh" class="mt-3">
          <v-card-text class="card-flex">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span class="primary--text overline font-weight-medium ml-3"
                >Préparations planifiés</span
              >
              <ScheduledPrepEditor small> </ScheduledPrepEditor>
            </v-row>

            <div class="small-card-scroller dense-table">
              <ScheduledPrepGrid :item-per-page="10"></ScheduledPrepGrid>
            </div>
          </v-card-text>
        </v-card>
        <v-card height="20vh" class="mt-3">
          <v-card-text class="card-flex">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span
                class="primary--text overline font-weight-medium ml-3"
                style="cursor: pointer;"
                @click="$router.push({ name: 'DeliverySlipIndex' })"
                >Commandes ouvertes</span
              >
              <v-btn
                small
                text
                class="btn-success-transparent"
                color="success"
                :to="{ name: 'DeliverySlipCreator' }"
              >
                <v-icon left x-small>fa-plus</v-icon>
                Nouveau
              </v-btn>
            </v-row>
            <div class="small-card-scroller dense-table">
              <OrderGrid :loading="loading" class="dense-table"></OrderGrid>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-else
      class="f-s"
      align="stretch"
      :dense="$vuetify.breakpoint.smAndDown"
    >
      <v-col
        cols="12"
        sm="6"
        style="
            display: flex;
            flex-direction: column;
            align-items: stretch;
            align-content: stretch;
            justify-items: stretch;
            justify-content: stretch;
        "
      >
        <div style="height: 36px; width: 100%"></div>
        <v-card
          height="60vh"
          class="mt-3"
          style="flex-grow: 1; flex-shrink: 0;"
        >
          <v-card-text style="height: 100%">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span
                class="overline font-weight-medium primary--text ml-3"
                style="cursor: pointer;"
                @click="$router.push({ name: 'PreparationSlipIndex' })"
                >Bons de préparation récents</span
              >
              <v-btn
                small
                text
                class="btn-success-transparent"
                color="success"
                :to="{ name: 'PreparationSlipEditor' }"
              >
                <v-icon left x-small>fa-plus</v-icon>
                Nouveau
              </v-btn>
            </v-row>
            <div class="small-card-scroller dense-table">
              <ProductionGrid :loading="loading"></ProductionGrid>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" :order="1" :order-sm="2">
        <v-row
          align="center"
          justify="end"
          no-gutters
          :class="{ 'py-3': $vuetify.breakpoint.xsOnly }"
        >
          <ProductionDialog></ProductionDialog>
          <div
            class="py-1"
            style="width: 1px;"
            v-if="$vuetify.breakpoint.xsOnly"
          ></div>
          <InventoryWasteDialog></InventoryWasteDialog>
        </v-row>
        <v-card height="30vh" class="mt-3">
          <v-card-text class="card-flex">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span class="primary--text overline font-weight-medium ml-3"
                >Préparations planifiés</span
              >
              <ScheduledPrepEditor small> </ScheduledPrepEditor>
            </v-row>

            <div class="small-card-scroller dense-table">
              <ScheduledPrepGrid :item-per-page="10"></ScheduledPrepGrid>
            </div>
          </v-card-text>
        </v-card>
        <v-card height="30vh" class="mt-3">
          <v-card-text class="card-flex">
            <v-row
              no-gutters
              align="center"
              justify="space-between"
              class="small-card-title"
            >
              <span
                class="primary--text overline font-weight-medium ml-3"
                style="cursor: pointer;"
                @click="$router.push({ name: 'DeliverySlipIndex' })"
                >Commandes ouvertes</span
              >
              <v-btn
                small
                text
                class="btn-success-transparent"
                color="success"
                :to="{ name: 'DeliverySlipCreator' }"
              >
                <v-icon left x-small>fa-plus</v-icon>
                Nouveau
              </v-btn>
            </v-row>
            <div class="small-card-scroller dense-table">
              <OrderGrid :loading="loading" class="dense-table"></OrderGrid>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row align="center" justify="end" no-gutters class="f-s my-2">
      <v-col align-self="end" :order="1" :order-sm="2">
        <v-row no-gutters justify="end">
          <ReportSender></ReportSender>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  ProductionGrid,
  OrderGrid,
  PinnedProductChart,
  CorrectionProductChart,
  InventoryExpirationAndWasteGrid,
  InventoryExpirationAndWasteFilter
} from "../components";
import {
  InventoryWasteDialog,
  ProductionDialog
} from "@/modules/Inventory/components";
import { ReportSender } from "@/modules/InventoryTransactionNotification/components";
import {
  ScheduledPrepEditor,
  ScheduledPrepGrid
} from "@/modules/PreparationSlip/components";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "StatisticsIndex",
  components: {
    InventoryWasteDialog,
    ProductionDialog,
    ProductionGrid,
    OrderGrid,
    ReportSender,
    ScheduledPrepEditor,
    ScheduledPrepGrid,
    PinnedProductChart,
    CorrectionProductChart,
    InventoryExpirationAndWasteGrid,
    InventoryExpirationAndWasteFilter
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData();
    });
  },
  beforeRouteUpdate() {
    this.getData();
  },
  computed: {
    ...mapGetters([
      "getProducts",
      "getIsAdmin",
      "getDeliverySlips",
      "getExpirations",
      "getWastes"
    ]),
    getOpenOrderCount() {
      const orders = this.getDeliverySlips.filter(
        x => x.is_closed === false && x.is_deleted === false
      );
      return orders.length;
    },
    getExpirationTabColor() {
      let color = "primary";
      if (
        this.getWastes.filter(
          x => moment().diff(moment(x.created), "days") <= 2
        ).length > 0
      ) {
        color = "error";
      } else if (
        this.getExpirations.filter(x => x.expiration_threshold !== 0).length > 0
      ) {
        color = "warning";
      }
      return color;
    }
  },
  data() {
    return {
      tabs: 0,
      tabs2: 0,
      tabChart: 0,
      loading: false,
      chartLoading: false,
      itemPerPage: 17,
      nowFilter: {
        period: [
          moment()
            .subtract(2, "d")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        ],
        start: moment()
          .subtract(2, "d")
          .format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      },
      showDetails: false,
      correctionSearch: "",
      correctionDelta: 1,
      correctionDeltaItems: [
        { value: 1, text: "Depuis hier" },
        { value: 3, text: "3 derniers jours" },
        { value: 7, text: "7 derniers jours" }
      ],
      correctionSortItems: [
        { value: "correction_value", text: "Valeur monétaire" },
        { value: "correction_value_mean", text: "Correction moyenne" }
      ],
      correctionSort: "correction_value",
      expirationFilter: {
        showExpiration: true,
        showWaste: true
      }
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadExpirations");
        await Promise.all([
          this.$store.dispatch("loadWastes"),
          this.$store.dispatch("loadDefaultDailySetting"),
          this.$store.dispatch("loadSuppliers"),
          this.$store.dispatch("loadWasteCauses"),
          this.$store.dispatch("loadRecipes"),
          this.$store.dispatch("loadProducts"),
          this.$store.dispatch("loadPreparationSlipTemplates"),
          this.$store.dispatch("loadPreparationSlips", { take: 10 }),
          this.$store.dispatch("loadDeliverySlips")
        ]);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.scroller {
  overflow-y: auto;
}
.stats-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: center;
  justify-content: center;
}
.card-flex {
  height: 100%;
  overflow-y: auto;
}
.small-card-title {
  position: absolute;
  width: 95.9%;
  background-color: white;
  z-index: 1;
  padding-top: 8px;
  padding-bottom: 5px;
  top: 0;
  left: 0;
  span:first-of-type {
    margin-left: 16px !important;
  }
}
.small-card-scroller {
  margin-top: 25px;
  width: 100%;
}
</style>
